import { useSelector } from "react-redux";
import { PrivateRoutes } from "./privateRoutes";
import { PublicRoutes } from "./publicRoutes";
import { RootState } from "../redux/Reducer";

export const RootRoutes = () => {
    const token = useSelector<RootState>((state) => state?.authData?.authData.token);

    return (
        <>
            {token ? <PrivateRoutes /> : <PublicRoutes />}
        </>
    );
};
